BaseLayer = require './base-layer'
PopupMixin = require 'mixins/map-popup'

module.exports = App.PathLayerComponent = BaseLayer.extend PopupMixin,
  leafletOptions: [
    'stroke'
    'color'
    'weight'
    'opacity'
    'fill'
    'fillColor'
    'fillOpacity'
    'fillRule'
    'dashArray'
    'lineCap'
    'lineJoin'
    'clickable'
    'pointerEvents'
    'className'
  ]
  leafletEvents: [
    'click'
    'dblclick'
    'mousedown'
    'mouseover'
    'mouseout'
    'contextmenu'
    'add'
    'remove'
    'popupopen'
    'popupclose'
  ]
  leafletStyleProperties: [
    'stroke'
    'color'
    'weight'
    'opacity'
    'fill'
    'fillColor'
    'fillOpacity'
    'fillRule'
    'dashArray'
    'lineCap'
    'lineJoin'
    'clickable'
    'pointerEvents'
    'className'
  ]
  layerSetup: ->
    @_super.apply this, arguments
    @_addStyleObservers()
    return
  layerTeardown: ->
    @_removeStyleObservers()
    @_super.apply this, arguments
    return
  _addStyleObservers: ->
    @_styleObservers = {}
    @get('leafletStyleProperties').forEach ((property) ->

      @_styleObservers[property] = ->
        value = @get(property)
        @_layer.setStyle property: value
        return

      @addObserver property, this, @_styleObservers[property]
      return
    ), this
    return
  _removeStyleObservers: ->
    @get('leafletStyleProperties').forEach ((property) ->
      @removeObserver property, this, @_styleObservers[property]
      delete @_styleObservers[property]
      return
    ), this
    return
